import request from '@/utils/request';

export function save(data) {
  return request({
    url: 'v1/version/save',
    method: 'post',
    data,
  });
}

export function fetch(versionNumber) {
  return request({
    url: `v1/version/${versionNumber}`,
    method: 'get',
  });
}

export function fetchList() {
  return request({
    url: 'v1/version/list',
    method: 'get',
  });
}
